// 通知公告
import {
  basePost
} from '../utils/request';

// 个人中心通知列表
export function getNoticeList(data) {
  return basePost('/notice/getNoticeList', data)
}
// 获取通知详情
export function getNoticeDetail(data) {
  return basePost('/notice/getNoticeDetail', data)
}
// 通知推荐弹框
export function getNotice(data) {
  return basePost('/notice/getNotice', data)
}
// 通知标记已读
export function readNotice(data) {
  return basePost('/notice/readNotice', data)
}


// 个人中心估值记录
export function getValuateList(data) {
  return basePost('/notice/getValuationList', data)
}
